import { TooltipV2 } from 'builder/components/Tooltip'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { HorizontalSlider } from 'builder/components/HorizontalSlider'
import { SliderContainer, ValueContainer, Value } from './styles'

type Props = {
  value: number
  onChange?: (value: number) => void
  disabledTooltip?: string
  isDisabled?: boolean
  testId?: string
  defaultValue?: number
  step?: number
  unit?: string
  min?: number
  max?: number
  isIntermediateDotsDisabled?: boolean
}

/**
 * Absolute means that the value can be any number in the range,
 * without transforming it to a relative value
 */
export const GenericAbsoluteSlider = (props: Props) => {
  const {
    value,
    onChange,
    disabledTooltip,
    isDisabled,
    testId,
    unit = '%',
    defaultValue = 100,
    min = 50,
    max = 150,
    step = 10,
    isIntermediateDotsDisabled,
  } = props
  const { isAboveTablet } = useMediaQueries()

  const prettify = (value: number) => `${value}${unit || ''}`

  const prettifiedValue = prettify(value)

  return (
    <TooltipV2
      value={disabledTooltip}
      width={250}
      multiline={true}
      position="bottom"
      isActive={isDisabled}
    >
      <SliderContainer
        data-testid={testId}
        data-value={value}
        data-value-prettified={prettifiedValue}
      >
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettify(min)}</Value>
          </ValueContainer>
        )}
        <HorizontalSlider
          disabled={!!isDisabled}
          defaultValue={defaultValue}
          value={value}
          step={step}
          min={min}
          max={max}
          onChange={onChange}
          isIntermediateDotsDisabled={isIntermediateDotsDisabled}
        />
        {!isAboveTablet && (
          <ValueContainer>
            <Value>{prettify(max)}</Value>
          </ValueContainer>
        )}
        {isAboveTablet && (
          <ValueContainer>
            <Value>{prettifiedValue}</Value>
          </ValueContainer>
        )}
      </SliderContainer>
    </TooltipV2>
  )
}
